export default {
  ja:[
    "住所などの情報",
    "郵便番号(ハイフンなし)",
    "電話番号(ハイフンなし)",
    "誕生日(例: 27)",
    "誕生月(例: 07)",
    "誕生年(例: 2006)",
    "性別",
    "女性",
    "男性",
    "戻る",
    "アップデート"
  ],
  en: [
    "Your delivery address",
    "Postal code",
    "Phone number",
    "Birth date ex:27",
    "Birth month ex:07",
    "Birth year ex: 2006",
    "Please select your gender",
    "female",
    "male",
    "cancel",
    "update",
  ]
}
